import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIMembers extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  putUserId = async (
    userId: UUID,
    { ...body }: types.CompanyMemberUpdate,
  ): Promise<types.UserResponse> => {
    let res = await this._fetch({
      url: `/companies/members/${userId}`,
      method: "PUT",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  deleteUserId = async (userId: UUID): Promise<{ message: string }> => {
    let res = await this._fetch({
      url: `/companies/members/${userId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
